import React, { useState, useEffect } from "react";
import { X, Calendar, Loader } from "lucide-react";
import apiService from "../services/api";
import "../styles/MonthSelectionModal.css";

const MonthSelectionModal = ({ onClose, onSelect, title }) => {
  const [availableMonths, setAvailableMonths] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAvailableMonths();
  }, []);

  const loadAvailableMonths = async () => {
    try {
      setLoading(true);
      // Load months from both presence and dashboard endpoints
      const [presenceResponse, dashboardResponse] = await Promise.all([
        apiService
          .getPresenceAvailableMonths()
          .catch(() => ({ success: false, months: [] })),
        apiService
          .getAvailableMonths()
          .catch(() => ({ success: false, data: [] })),
      ]);

      const presenceMonths = presenceResponse.months || [];
      const dashboardMonths = dashboardResponse.data || [];

      // Combine and deduplicate months, then sort descending
      const allMonths = [
        ...new Set([...presenceMonths, ...dashboardMonths]),
      ].sort((a, b) => b.localeCompare(a));

      setAvailableMonths(allMonths);
    } catch (error) {
      console.error("Failed to load available months:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatMonth = (monthStr) => {
    if (!monthStr) return "";
    const [year, month] = monthStr.split("-");
    const monthNames = [
      "ינואר",
      "פברואר",
      "מרץ",
      "אפריל",
      "מאי",
      "יוני",
      "יולי",
      "אוגוסט",
      "ספטמבר",
      "אוקטובר",
      "נובמבר",
      "דצמבר",
    ];
    return `${monthNames[parseInt(month) - 1]} ${year}`;
  };

  const handleMonthSelect = (month) => {
    onSelect(month);
    onClose();
  };

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div
        className='modal-content month-selection-modal'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='modal-header'>
          <h2>
            <Calendar size={24} />
            {title || "בחר חודש"}
          </h2>
          <button className='modal-close' onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className='modal-body'>
          {loading ? (
            <div className='loading-state'>
              <Loader className='spinner' size={32} />
              <p>טוען חודשים זמינים...</p>
            </div>
          ) : availableMonths.length === 0 ? (
            <div className='empty-state'>
              <Calendar size={48} />
              <p>אין חודשים זמינים</p>
            </div>
          ) : (
            <div className='months-grid'>
              {availableMonths.map((month) => (
                <button
                  key={month}
                  className='month-btn'
                  onClick={() => handleMonthSelect(month)}
                >
                  <Calendar size={18} />
                  <span>{formatMonth(month)}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className='modal-footer'>
          <button className='btn-secondary' onClick={onClose}>
            ביטול
          </button>
        </div>
      </div>
    </div>
  );
};

export default MonthSelectionModal;
